import { render, staticRenderFns } from "./checkoutCart.vue?vue&type=template&id=061baff0"
import script from "./checkoutCart.vue?vue&type=script&lang=js"
export * from "./checkoutCart.vue?vue&type=script&lang=js"
import style0 from "./checkoutCart.vue?vue&type=style&index=0&id=061baff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports